const ROOT = 'AGENCY_CONTRACT_V2_MUTATIONS_';

const actionTypes = {
  INVITE_REQUEST: `${ROOT}INVITE_REQUEST`,
  INVITE_SUCCESS: `${ROOT}INVITE_SUCCESS`,
  INVITE_GATE_FAILED: `${ROOT}INVITE_GATE_FAILED`,
  INVITE_ERROR: `${ROOT}INVITE_ERROR`,
  REMOVE_REQUEST: `${ROOT}REMOVE_REQUEST`,
  REMOVE_SUCCESS: `${ROOT}REMOVE_SUCCESS`,
  REMOVE_ERROR: `${ROOT}REMOVE_ERROR`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actionTypes;
